import { render, staticRenderFns } from "./trainExamList.vue?vue&type=template&id=0b7e7b53&scoped=true&"
import script from "./trainExamList.vue?vue&type=script&lang=ts&"
export * from "./trainExamList.vue?vue&type=script&lang=ts&"
import style0 from "./trainExamList.vue?vue&type=style&index=0&id=0b7e7b53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7e7b53",
  null
  
)

export default component.exports